export const getExpiredCardDateString = (month: number, year: number) => {
  return `${month.toString().padStart(2, '0')}/${year.toString().slice(-2)}`;
};
